import React, { memo } from 'react';
import { InventoryCountStatus as status } from 'types/inventory';
import { InventoryCountTabProps } from './InventoryCount.props';
import { InventoryTabContent } from './InventoryTabContent';

export const PendingInventory = memo<InventoryCountTabProps>((props) => {
  return (
    <InventoryTabContent
      status={status.PENDING_PICKUP}
      {...props}></InventoryTabContent>
  );
});
